<div class="legal-container">
    <div class="header-left">
        <button type="button" class="back-btn" (click)="goBack()">
            <i class="fas fa-arrow-left"></i>
            <span>Retour à l'accueil</span>
        </button>
    </div>
    <header class="legal-header">
        <div class="logo-container">
            <img src="assets/images/logo-2.png" alt="YokaStar Logo">
        </div>
        <h1>Politique relative aux Cookies</h1>
        <p class="subtitle">Dernière mise à jour : {{ currentDate | date: 'longDate' }}</p>
    </header>

    <main class="legal-content">
        <section class="intro-section">
            <p>
                Cette politique relative aux cookies explique comment <strong>YokaStar</strong> utilise les cookies et technologies similaires
                pour améliorer votre expérience sur notre plateforme.
            </p>
        </section>

        <section class="what-are-cookies-section">
            <h2><i class="fas fa-cookie icon"></i> Que sont les cookies ?</h2>
            <p>
                Les cookies sont de petits fichiers texte stockés sur votre appareil lorsque vous visitez notre site web.
                Ils nous aident à vous fournir une meilleure expérience et à améliorer nos services.
            </p>
        </section>

        <section class="types-cookies-section">
            <h2><i class="fas fa-list icon"></i> Types de Cookies que nous utilisons</h2>
            <div class="grid-layout">
                <div class="cookie-type">
                    <i class="fas fa-user-lock"></i>
                    <h3>Cookies Essentiels</h3>
                    <ul>
                        <li>Authentification des utilisateurs</li>
                        <li>Sécurité du site</li>
                        <li>Fonctionnalités de base</li>
                    </ul>
                </div>
                <div class="cookie-type">
                    <i class="fas fa-chart-line"></i>
                    <h3>Cookies de Performance</h3>
                    <ul>
                        <li>Analyse du trafic</li>
                        <li>Mesure des performances</li>
                        <li>Optimisation du site</li>
                    </ul>
                </div>
                <div class="cookie-type">
                    <i class="fas fa-bullseye"></i>
                    <h3>Cookies de Fonctionnalité</h3>
                    <ul>
                        <li>Préférences utilisateur</li>
                        <li>Personnalisation</li>
                        <li>Mémorisation des choix</li>
                    </ul>
                </div>
                <div class="cookie-type">
                    <i class="fas fa-ad"></i>
                    <h3>Cookies Marketing</h3>
                    <ul>
                        <li>Publicité ciblée</li>
                        <li>Suivi des conversions</li>
                        <li>Analyse marketing</li>
                    </ul>
                </div>
            </div>
        </section>

        <section class="control-cookies-section">
            <h2><i class="fas fa-sliders-h icon"></i> Comment contrôler les cookies</h2>
            <div class="grid-layout">
                <div class="control-item">
                    <h3>Paramètres du navigateur</h3>
                    <p>
                        Vous pouvez configurer votre navigateur pour accepter ou refuser les cookies.
                        Consultez l'aide de votre navigateur pour plus d'informations.
                    </p>
                </div>
                <div class="control-item">
                    <h3>Outils de gestion</h3>
                    <p>
                        Notre plateforme propose des outils pour gérer vos préférences en matière de cookies.
                        Vous pouvez les trouver dans les paramètres de votre compte.
                    </p>
                </div>
            </div>
        </section>

        <section class="third-party-section">
            <h2><i class="fas fa-shield-alt icon"></i> Cookies Tiers</h2>
            <p>
                Certains cookies sont placés par des services tiers que nous utilisons pour améliorer notre plateforme.
                Ces services peuvent inclure :
            </p>
            <ul>
                <li>Services d'analyse (Google Analytics)</li>
                <li>Services de paiement</li>
                <li>Réseaux sociaux</li>
                <li>Services de streaming vidéo</li>
            </ul>
        </section>

        <section class="updates-section">
            <h2><i class="fas fa-sync icon"></i> Mises à jour de la Politique</h2>
            <p>
                Nous pouvons mettre à jour cette politique de temps à autre. Les modifications seront publiées sur cette page
                avec la date de mise à jour. Nous vous encourageons à consulter régulièrement cette politique.
            </p>
        </section>

        <section class="contact-section">
            <h2><i class="fas fa-envelope icon"></i> Contact</h2>
            <p>
                Pour toute question concernant notre utilisation des cookies, veuillez nous contacter :
            </p>
            <div class="contact-card">
                <p><strong>Email : </strong> <a href="mailto:privacy&#64;yokastar.com">privacy&#64;yokastar.com</a></p>
                <p><strong>Adresse :</strong> 11 Bis, Av. Okapi; Q/Congo C/Ngaliema Kinshasa/ R.D.Congo</p>
            </div>
        </section>
    </main>

    <app-legal-footer></app-legal-footer>
</div> 